export default __webpack_public_path__ + "img/cTNLspIP.97120abe.svg";